<template>
  <div style="margin-top:20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Manage Vehicle Status Manager Settings</span><br/>
    </div>

    <div v-if="!loading" style="text-align: left; color: #666" class="d-flex align-items-center justify-content-center">
      <form @submit.prevent="save_config">
        <table width="90%" style="font-size: 18px; font-weight: bold" cellpadding="10px">
          <tr>
            <td align="right" width="500">Enabled</td>
            <td width="800"><b-form-select v-model="model.vehicle_status_management_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Show Tag Filters</td>
            <td width="800"><b-form-select v-model="model.vehicle_status_management_show_tag_filters" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Vehicle Tag Filter</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_vehicle_tag_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Vehicle Base Filter</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_vehicle_base_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Yard Status Change Vehicle Tag Filter</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_yard_vehicle_tag_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Dirty After Days Vehicle Tag Filter</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_dirty_after_days_vehicle_tag_filter" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Dirty After Days (instead of yard arrival)</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_dirty_after_days" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Status Aliases</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_status_aliases" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Yard Leave Miles</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_yard_leave_miles" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Skip Vehicles</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_skip_vehicles" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.tenant == 'anderson-759g468f' || user.tenant== 'tbn-demo' || user.tenant== 'initek-tbn'">
            <td align="right" width="500">Tote Options</td>
            <td width="800"><b-form-textarea rows="3" v-model="model.vehicle_status_management_tote_config" type="text"></b-form-textarea></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type == 'CM'">
            <td align="right" width="500">Depart In Offset Minutes</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_departs_in_offset_minutes" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type == 'TBN'">
            <td align="right" width="500">Use Driver Start For Next Depart Time</td>
            <td width="800"><b-form-select v-model="model.vehicle_status_management_use_driver_start_time" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Future Hours</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_future_hours" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Future Bookings Count</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_future_bookings_count" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Portal Visible Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_columns = !view_customize_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Standalone Visible Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_standalone_columns = !view_customize_standalone_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Standalone Cleaning Visible Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_cleaning_columns = !view_customize_cleaning_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Standalone Maintenance Visible Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_maintenance_columns = !view_customize_maintenance_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Standalone Driver Visible Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_driver_columns = !view_customize_driver_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>

          <tr>
            <td align="right" width="500">Mobile Visible Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_mobile_columns = !view_customize_mobile_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Extra Update Fields</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_visible_update_fields" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Portal Visible History Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_history_columns = !view_customize_history_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Email OOS Recipient</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_email_oos_recipient" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>

          <tr>
            <td align="right" width="500">Auto Set Ready Enabled</td>
            <td width="800"><b-form-select v-model="model.vehicle_status_management_auto_set_ready_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Clear Notes on Clean Enabled</td>
            <td width="800"><b-form-select v-model="model.vehicle_status_management_clear_notes_on_clean_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Maintenance Summary Enabled</td>
            <td width="800"><b-form-select v-model="model.vehicle_status_management_maint_summary_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Schedule Options</td>
            <td width="800"><b-form-textarea rows="3" v-model="model.vehicle_status_management_schedule_options" type="text"></b-form-textarea></td>
            <td width="250">&nbsp;</td>
          </tr>

          <tr v-if="is_admin">
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isAdvVisible')">+ Advanced</span></td>
            <td></td>
            <td></td>
          </tr>
          <template v-if="toggle.isAdvVisible">
            <tr>
              <td align="right" width="500">Driver Confirmation Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_confirmation_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Simple Maintenance Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_maint_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">DVIR Maintenance Mode Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_dvir_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'TBN'">
              <td align="right" width="500">TBN Maintenance Mode Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_tbn_status_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'TBN'">
              <td align="right" width="500">TBN OOS Events Filter</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_tbn_oos_events_filter" type="text" placeholder="ex: *,-Lack of Drivers"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">RTA Maintenance Mode Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_rta_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Fleetio Maintenance Mode Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_fleetio_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Fleetio Advanced Mode Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_fleetio_advanced_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Fleetio Status To Mark for PM</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_fleetio_pm_status" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Fleetio Status To Mark for OOS</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_fleetio_oos_status" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Unifi Status Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_unifi_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Date Time Format Override</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_date_time_format" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Extra Vehicle Stats Enabled (odo, fuel, def)</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_stats_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Separate Clean vs. Wash Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_washed_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Reset Clean / Wash On Dirty Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_reset_clean_wash_on_dirty_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Booking Leave OUT Status Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_booking_leave_logic_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Booking Return DIRTY Status Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_booking_return_logic_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Yard Leave OUT Status Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_yard_leave_logic_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Yard Return DIRTY Status Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_yard_return_logic_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Confirmation Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_sms_confirmation_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Invalid Message Response Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_sms_invalid_msg_response_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Include Booking Only Vehicles Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_include_booking_only_vehicles_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Yard Filter</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_yard_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Include Vehicle Info Only Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_include_vehicle_info_only_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Future Bookings On Separate Row</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_future_booking_on_separate_row" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Show ETA For OUT Vehicles</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_show_eta_for_out_vehicles" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Show Recently Departed Vehicles</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_show_recent_departures" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Standalone Font Size Override</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_font_size" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">Standalone Window Height Override</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_standalone_window_height" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">History Statuses</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_history_statuses" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">User Customizable Fields</td>
              <td width="800"><b-form-textarea v-model="model.vehicle_status_management_user_customizable_fields" rows="3" placeholder="Comma-delimited list of field keys that users can customize in the 'more info' modal. Leave empty to allow all fields."/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">History Customizable Fields</td>
              <td width="800"><b-form-textarea v-model="model.vehicle_status_management_history_customizable_fields" rows="3" placeholder="Comma-delimited list of history field keys that can be customized. Leave empty to allow all history fields."/></td>
              <td width="250">&nbsp;</td>
            </tr>

          </template>


        </table>

        <hr/>
        <div style="position: relative" class="d-flex align-items-center justify-content-center">
          <b-btn size="lg" type="submit" variant="success" id="save-user-submit">Save</b-btn>
          &nbsp;&nbsp;<b-btn size="lg" @click="load_data()">Cancel</b-btn>
        </div>

      </form>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

    <b-modal title="Customize Columns - Portal" size="xl" v-model="view_customize_columns" @show="syncCustomizeColumnsWithVisibleFields" ok-only>
      <br/>
      <h4>Customize Portal Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        v-model="customizeColumnsValue"
        field-type="main"
        :available-fields="availableFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeColumns">Reset to Default</b-button>
      <br/><br/>
      <small class="text-muted">Changes will be saved when you click Save on the settings page.</small>
    </b-modal>

    <b-modal title="Customize Columns - Standalone" size="xl" v-model="view_customize_standalone_columns" @show="syncCustomizeStandaloneColumnsWithVisibleFields" ok-only>
      <br/>
      <h4>Customize Standalone Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        v-model="customizeStandaloneColumnsValue"
        field-type="main"
        :available-fields="availableFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeStandaloneColumns">Reset to Default</b-button>
      <br/><br/>
      <small class="text-muted">Changes will be saved when you click Save on the settings page.</small>
    </b-modal>

    <b-modal title="Customize Columns - Cleaning" size="xl" v-model="view_customize_cleaning_columns" @show="syncCustomizeCleaningColumnsWithVisibleFields" ok-only>
      <br/>
      <h4>Customize Cleaning Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        v-model="customizeCleaningColumnsValue"
        field-type="main"
        :available-fields="availableFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeCleaningColumns">Reset to Default</b-button>
      <br/><br/>
      <small class="text-muted">Changes will be saved when you click Save on the settings page.</small>
    </b-modal>

    <b-modal title="Customize Columns - Maintenance" size="xl" v-model="view_customize_maintenance_columns" @show="syncCustomizeMaintenanceColumnsWithVisibleFields" ok-only>
      <br/>
      <h4>Customize Maintenance Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        v-model="customizeMaintenanceColumnsValue"
        field-type="main"
        :available-fields="availableFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeMaintenanceColumns">Reset to Default</b-button>
      <br/><br/>
      <small class="text-muted">Changes will be saved when you click Save on the settings page.</small>
    </b-modal>

    <b-modal title="Customize Columns - Driver" size="xl" v-model="view_customize_driver_columns" @show="syncCustomizeDriverColumnsWithVisibleFields" ok-only>
      <br/>
      <h4>Customize Driver Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        v-model="customizeDriverColumnsValue"
        field-type="main"
        :available-fields="availableFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeDriverColumns">Reset to Default</b-button>
      <br/><br/>
      <small class="text-muted">Changes will be saved when you click Save on the settings page.</small>
    </b-modal>

    <b-modal title="Customize Columns - Mobile" size="xl" v-model="view_customize_mobile_columns" @show="syncCustomizeMobileColumnsWithVisibleFields" ok-only>
      <br/>
      <h4>Customize Mobile Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        v-model="customizeMobileColumnsValue"
        field-type="main"
        :available-fields="availableFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeMobileColumns">Reset to Default</b-button>
      <br/><br/>
      <small class="text-muted">Changes will be saved when you click Save on the settings page.</small>
    </b-modal>

    <b-modal title="Customize Columns - History" size="xl" v-model="view_customize_history_columns" @show="syncCustomizeHistoryColumnsWithVisibleFields" ok-only>
      <br/>
      <h4>Customize History Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        v-model="customizeHistoryColumnsValue"
        field-type="history"
        :available-fields="availableHistoryFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeHistoryColumns">Reset to Default</b-button>
      <br/><br/>
      <small class="text-muted">Changes will be saved when you click Save on the settings page.</small>
    </b-modal>
  </div>

</template>
<script>
import {get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
import {mapState} from "vuex";
import { VSM_FIELDS, VSM_HISTORY_FIELDS } from '../utils/vsm_fields'
import VsmFieldSelector from './VsmFieldSelector.vue'

export default {
  name: 'tenant_config',
  components: {
    VsmFieldSelector
  },

  data() {
    return {
      group_name: 'general',
      add_yard_model: {},
      manage_sos_yards: false,
      model: {},
      general_model: {},
      general_advanced_model: {},
      toggle: {},
      summary: {},
      view_customize_columns: false,
      customizeColumnsValue: '',
      defaultColumnsValue: '', // Store the original value when modal opens
      view_customize_standalone_columns: false,
      customizeStandaloneColumnsValue: '',
      defaultStandaloneColumnsValue: '', // Store the original value when modal opens
      view_customize_cleaning_columns: false,
      customizeCleaningColumnsValue: '',
      defaultCleaningColumnsValue: '', // Store the original value when modal opens
      view_customize_maintenance_columns: false,
      customizeMaintenanceColumnsValue: '',
      defaultMaintenanceColumnsValue: '', // Store the original value when modal opens
      view_customize_driver_columns: false,
      customizeDriverColumnsValue: '',
      defaultDriverColumnsValue: '', // Store the original value when modal opens
      view_customize_mobile_columns: false,
      customizeMobileColumnsValue: '',
      defaultMobileColumnsValue: '', // Store the original value when modal opens
      view_customize_history_columns: false,
      customizeHistoryColumnsValue: '',
      defaultHistoryColumnsValue: '', // Store the original value when modal opens
      loading: true,
      isNotSysadmin: false,
      isSamaraType: false,
      yardsLength: 0,
      modal_help: {},
      objectKeyList: [],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    toggle_help(field) {
      if (!(field in this.modal_help))
        this.modal_help[field] = true
      else
        this.modal_help[field] = !this.modal_help[field]
      this.$forceUpdate();
    },
    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results

        // Auto-fill user_customizable_fields with all VSM fields if empty
        const userCustomizableKey = 'vehicle_status_management_user_customizable_fields'
        const visibleFieldsKey = 'vehicle_status_management_visible_fields'
        
        const visibleFields = this.model[visibleFieldsKey] || ''
        const userCustomizableFields = this.model[userCustomizableKey] || ''
        
        // If user_customizable_fields is empty, fill it with all possible VSM field keys
        if (!userCustomizableFields || userCustomizableFields.trim() === '') {
          const allFieldKeys = VSM_FIELDS.map(f => f.key).join(',')
          this.model[userCustomizableKey] = allFieldKeys
        } else if (visibleFields && visibleFields.trim() !== '') {
          // Ensure user_customizable_fields contains all fields from visible_fields
          const visibleKeys = visibleFields.split(',').map(k => k.trim()).filter(k => k)
          const customizableKeys = userCustomizableFields.split(',').map(k => k.trim()).filter(k => k)
          
          // Find fields in visible_fields that are not in user_customizable_fields
          const missingKeys = visibleKeys.filter(k => !customizableKeys.includes(k))
          
          // If there are missing fields, add them to user_customizable_fields
          if (missingKeys.length > 0) {
            const combinedKeys = [...customizableKeys, ...missingKeys]
            this.model[userCustomizableKey] = combinedKeys.join(',')
          }
        }

        // Auto-fill history_customizable_fields with all history fields if empty
        const historyCustomizableKey = 'vehicle_status_management_history_customizable_fields'
        const visibleHistoryFieldsKey = 'vehicle_status_management_visible_history_fields'
        
        const visibleHistoryFields = this.model[visibleHistoryFieldsKey] || ''
        const historyCustomizableFields = this.model[historyCustomizableKey] || ''
        
        // If history_customizable_fields is empty, fill it with all possible history field keys
        if (!historyCustomizableFields || historyCustomizableFields.trim() === '') {
          const allHistoryFieldKeys = VSM_HISTORY_FIELDS.map(f => f.key).join(',')
          this.model[historyCustomizableKey] = allHistoryFieldKeys
        } else if (visibleHistoryFields && visibleHistoryFields.trim() !== '') {
          // Ensure history_customizable_fields contains all fields from visible_history_fields
          const visibleHistoryKeys = visibleHistoryFields.split(',').map(k => k.trim()).filter(k => k)
          const customizableHistoryKeys = historyCustomizableFields.split(',').map(k => k.trim()).filter(k => k)
          
          // Find fields in visible_history_fields that are not in history_customizable_fields
          const missingHistoryKeys = visibleHistoryKeys.filter(k => !customizableHistoryKeys.includes(k))
          
          // If there are missing fields, add them to history_customizable_fields
          if (missingHistoryKeys.length > 0) {
            const combinedHistoryKeys = [...customizableHistoryKeys, ...missingHistoryKeys]
            this.model[historyCustomizableKey] = combinedHistoryKeys.join(',')
          }
        }

        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              //console.log('found plain object or array: key:'+key+ ' value: '+ setting);
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
        } catch(e) {
          console.log('error looping through keys',e)
        }

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async save_config() {
      try {
        window.scrollTo(0,0);
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        //return value to object 
        try {
          //console.log("this.objectKeyList: " + JSON.stringify(this.objectKeyList))
          for (const objkey of this.objectKeyList) {
            // Only parse if it's a string, and skip if it's already an object
            if (typeof this.model[objkey] === 'string') {
              try {
                let setting = JSON.parse(this.model[objkey])
                this.model[objkey] = setting
              } catch(parseError) {
                // If parsing fails, it might already be an object or invalid JSON
                // Skip this key and log the error
                console.log('vexception parsing object key ' + objkey + ':', parseError)
              }
            }
            // If it's already an object, leave it as is
          }
        } catch(e) {
          console.log('vexception parsing object keys' + e)
        }
       
        await update_tenant_config_settings(this.user.tenant, this.model, this.group_name)
        this.load_data()
        this.$emit('showAlert', 'Configuration Saved', 'success',5000)
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item,field,setting) {
      if (!item[field] && setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      } else if (item[field] && !setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    isPlainObject(value,key) {
      //console.log('isPlainObject, value:' + value + ', type of value:' + (typeof value))
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value) {
      return Array.isArray(value)
    },
    syncCustomizeColumnsWithVisibleFields() {
      // When modal opens, sync with current visible_fields setting
      const visibleFields = this.model.vehicle_status_management_visible_fields || ''
      this.customizeColumnsValue = visibleFields
      // Store the original value as the default for reset
      this.defaultColumnsValue = visibleFields
    },
    updateVisibleFieldsFromCustomize() {
      // Update the visible_fields model when customize columns changes
      this.model.vehicle_status_management_visible_fields = this.customizeColumnsValue
    },
    resetCustomizeColumns() {
      // Reset to the value that was in the field when the modal opened (the saved value)
      this.customizeColumnsValue = this.defaultColumnsValue
      this.updateVisibleFieldsFromCustomize()
    },
    syncCustomizeStandaloneColumnsWithVisibleFields() {
      const visibleFields = this.model.vehicle_status_management_visible_standalone_fields || ''
      this.customizeStandaloneColumnsValue = visibleFields
      // Store the original value as the default for reset
      this.defaultStandaloneColumnsValue = visibleFields
    },
    updateStandaloneFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_standalone_fields = this.customizeStandaloneColumnsValue
    },
    resetCustomizeStandaloneColumns() {
      // Reset to the value that was in the field when the modal opened (the saved value)
      this.customizeStandaloneColumnsValue = this.defaultStandaloneColumnsValue
      this.updateStandaloneFieldsFromCustomize()
    },
    syncCustomizeCleaningColumnsWithVisibleFields() {
      const visibleFields = this.model.vehicle_status_management_visible_cleaning_fields || ''
      this.customizeCleaningColumnsValue = visibleFields
      // Store the original value as the default for reset
      this.defaultCleaningColumnsValue = visibleFields
    },
    updateCleaningFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_cleaning_fields = this.customizeCleaningColumnsValue
    },
    resetCustomizeCleaningColumns() {
      // Reset to the value that was in the field when the modal opened (the saved value)
      this.customizeCleaningColumnsValue = this.defaultCleaningColumnsValue
      this.updateCleaningFieldsFromCustomize()
    },
    syncCustomizeMaintenanceColumnsWithVisibleFields() {
      const visibleFields = this.model.vehicle_status_management_visible_maintenance_fields || ''
      this.customizeMaintenanceColumnsValue = visibleFields
      // Store the original value as the default for reset
      this.defaultMaintenanceColumnsValue = visibleFields
    },
    updateMaintenanceFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_maintenance_fields = this.customizeMaintenanceColumnsValue
    },
    resetCustomizeMaintenanceColumns() {
      // Reset to the value that was in the field when the modal opened (the saved value)
      this.customizeMaintenanceColumnsValue = this.defaultMaintenanceColumnsValue
      this.updateMaintenanceFieldsFromCustomize()
    },
    syncCustomizeDriverColumnsWithVisibleFields() {
      const visibleFields = this.model.vehicle_status_management_visible_driver_fields || ''
      this.customizeDriverColumnsValue = visibleFields
      // Store the original value as the default for reset
      this.defaultDriverColumnsValue = visibleFields
    },
    updateDriverFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_driver_fields = this.customizeDriverColumnsValue
    },
    resetCustomizeDriverColumns() {
      // Reset to the value that was in the field when the modal opened (the saved value)
      this.customizeDriverColumnsValue = this.defaultDriverColumnsValue
      this.updateDriverFieldsFromCustomize()
    },
    syncCustomizeMobileColumnsWithVisibleFields() {
      const visibleFields = this.model.vehicle_status_management_visible_mobile_fields || ''
      this.customizeMobileColumnsValue = visibleFields
      // Store the original value as the default for reset
      this.defaultMobileColumnsValue = visibleFields
    },
    updateMobileFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_mobile_fields = this.customizeMobileColumnsValue
    },
    resetCustomizeMobileColumns() {
      // Reset to the value that was in the field when the modal opened (the saved value)
      this.customizeMobileColumnsValue = this.defaultMobileColumnsValue
      this.updateMobileFieldsFromCustomize()
    },
    syncCustomizeHistoryColumnsWithVisibleFields() {
      const visibleFields = this.model.vehicle_status_management_visible_history_fields || ''
      this.customizeHistoryColumnsValue = visibleFields
      // Store the original value as the default for reset
      this.defaultHistoryColumnsValue = visibleFields
    },
    updateHistoryFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_history_fields = this.customizeHistoryColumnsValue
    },
    resetCustomizeHistoryColumns() {
      // Reset to the value that was in the field when the modal opened (the saved value)
      this.customizeHistoryColumnsValue = this.defaultHistoryColumnsValue
      this.updateHistoryFieldsFromCustomize()
    },
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    availableFieldsForCustomize() {
      // Filter VSM fields based on user_customizable_fields setting
      const userCustomizableFields = this.model.vehicle_status_management_user_customizable_fields || ''
      
      // If empty, allow all fields
      if (!userCustomizableFields || userCustomizableFields.trim() === '') {
        return VSM_FIELDS
      }
      
      // Otherwise, only show fields that are in the user_customizable_fields list
      const allowedKeys = userCustomizableFields.split(',').map(k => k.trim()).filter(k => k)
      return VSM_FIELDS.filter(field => allowedKeys.includes(field.key))
    },
    availableHistoryFieldsForCustomize() {
      // Filter history fields based on history_customizable_fields setting
      const historyCustomizableFields = this.model.vehicle_status_management_history_customizable_fields || ''
      
      // If empty, allow all history fields
      if (!historyCustomizableFields || historyCustomizableFields.trim() === '') {
        return VSM_HISTORY_FIELDS
      }
      
      // Otherwise, only show fields that are in the history_customizable_fields list
      const allowedKeys = historyCustomizableFields.split(',').map(k => k.trim()).filter(k => k)
      return VSM_HISTORY_FIELDS.filter(field => allowedKeys.includes(field.key))
    },
    is_admin() {
      return this.user.role === 'admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    },
    customizeColumnsValue: {
      handler(newVal) {
        // Update the visible_fields model whenever customizeColumnsValue changes
        if (this.view_customize_columns) {
          this.model.vehicle_status_management_visible_fields = newVal
        }
      },
      immediate: false
    },
    customizeStandaloneColumnsValue: {
      handler(newVal) {
        if (this.view_customize_standalone_columns) {
          this.model.vehicle_status_management_visible_standalone_fields = newVal
        }
      },
      immediate: false
    },
    customizeCleaningColumnsValue: {
      handler(newVal) {
        if (this.view_customize_cleaning_columns) {
          this.model.vehicle_status_management_visible_cleaning_fields = newVal
        }
      },
      immediate: false
    },
    customizeMaintenanceColumnsValue: {
      handler(newVal) {
        if (this.view_customize_maintenance_columns) {
          this.model.vehicle_status_management_visible_maintenance_fields = newVal
        }
      },
      immediate: false
    },
    customizeDriverColumnsValue: {
      handler(newVal) {
        if (this.view_customize_driver_columns) {
          this.model.vehicle_status_management_visible_driver_fields = newVal
        }
      },
      immediate: false
    },
    customizeMobileColumnsValue: {
      handler(newVal) {
        if (this.view_customize_mobile_columns) {
          this.model.vehicle_status_management_visible_mobile_fields = newVal
        }
      },
      immediate: false
    },
    customizeHistoryColumnsValue: {
      handler(newVal) {
        if (this.view_customize_history_columns) {
          this.model.vehicle_status_management_visible_history_fields = newVal
        }
      },
      immediate: false
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";
</style>

